import api, { prepareQueryParameters } from "@/store/api";
import {AssetDetail} from "@/types";
import {downloadPDF, getFileFromHex} from "@/store/helpers";
import account from "@/store/modules/account";

export const defaultStatus = () => {
    return {
        total: 0,
        type_1: 0,
        type_2: 0,
        type_3: 0,
        type_4: 0,
    }
};

const emptyState = () => {
    return {
        item: {},
        items: [],
        data: [],
        filter: [],
        details: {},
        loading: false,
        status: defaultStatus,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        list(store: any, params: any) {
            store.commit("setItem", {});
            store.commit("setItems", []);
            // store.commit('setFilter', []);
            api.get(`messages/list?${prepareQueryParameters(params)}`).then(response => {
                store.commit('setItems', response.data.result);
                // store.commit('setFilter', data.data);
            }).catch(() => {
                store.commit('setItems', []);
                // store.commit('setFilter', []);
            })
        },
        messageDetail(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get(`messages/detail?${prepareQueryParameters(params)}`).then((response) => {
                    // store.commit("addDetail", { messageId, detail: data.data, index });
                    store.commit("setItem", response.data.result);
                    resolve(response.data.result);
                }).catch((error) => {
                    store.commit('setItem', {});
                    reject(error);
                })
            });
        },
        messageAttachment(store: any, { attachmentId, messageId }: { attachmentId: number, messageId: number; index: number }) {
            const newWindow = window.open();
            api.get(`messages/attachments?${prepareQueryParameters({ attachmentId, messageId })}`).then((response) => {
                const file = getFileFromHex(response.data);
                const fileURL = URL.createObjectURL(file);
                // @ts-ignore
                newWindow.location.href = fileURL;
            });
        },
        downloadReport(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get(`messages/download-report?${prepareQueryParameters(params)}`).then((response) => {
                    downloadPDF(response.data.result.file, response.data.result.name);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        downloadInstruction(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get(`messages/download-instruction?${prepareQueryParameters(params)}`).then((response) => {
                    downloadPDF(response.data.result.file, response.data.result.name);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        downloadConfirmation(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get(`messages/download-confirmation?${prepareQueryParameters(params)}`).then((response) => {
                    downloadPDF(response.data.result.file, response.data.result.name);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        markAsSeen(store: any, params: any) {
            if (account.state.tempUser.token) {
                params.clientToken = account.state.tempUser.token;
            }
            return new Promise((resolve, reject) => {
                api.post('messages/mark-as-seen', params).then((data: any) => {
                    store.dispatch('status');
                    resolve();
                }).catch(error => {
                    reject();
                });
            });
        },
        status(store: any) {
            api.get('messages/status').then(response => {
                store.commit('setStatus', response.data.result);
            }).catch(error => {
                store.commit('setStatus', defaultStatus);
            });
        },
    },
    mutations: {
        setStatus(state: any, data: any) {
            state.status = data;
        },
        setItems(state: any, data: any) {
            state.data = data;
            state.items = data;
        },
        setItem(state: any, data: any) {
            state.item = data;
        },
        setItemOpened(state: any, data: any) {
            state.items[data.index].opened = true;
        },
        setFilter(state: any, data: any) {
            for (const i in data) {
                const date = new Date(data[i].date);
                const year = date.getFullYear();
                if(!state.filter.includes(year)) {
                    state.filter.push(year);
                }
            }
            state.filter.sort(function(a:any,b:any){return b-a});
        },
        filter(state: any, filteredYear: any) {
            if (filteredYear) {
                state.items = [];
                const data = state.data;
                for (const i in data) {
                    const date = new Date(data[i].date);
                    const year = date.getFullYear();
                    if(year === filteredYear) {
                        state.items.push(data[i]);
                    }
                }
            } else {
                state.items = state.data;
            }
        },
        addDetail(state: any, { code, detail, index }: { code: string; detail: {}; index: number }) {
            state.details = { ...state.details, [code]: detail };
            const items = state.items;
            items[index].detail = detail;
            state.items = [...items];
        },
        setLoading(state: any, loading: boolean = false) {
            state.loading = loading;
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
